import React from 'react';
import { trackWhatsAppClick } from '../lib/xTracking';
import { ArrowRight } from 'lucide-react';

const tiers = [
  {
    label: 'Single Mandate',
    title: 'One Matter',
    desc: 'A defined outcome or complex matter requiring focused support.',
    cta: 'Discuss a mandate',
  },
  {
    label: 'Relationship',
    title: 'Multiple Matters',
    desc: 'An ongoing relationship across multiple matters as they arise.',
    cta: 'Explore a retainer',
  },
  {
    label: 'Dedicated',
    title: 'Bespoke',
    desc: 'For situations requiring deeper involvement, coordination and execution.',
    cta: 'Talk to us',
  },
];

export default function Pricing() {
  return (
    <section id="pricing" className="px-4 md:px-6 pt-6 md:pt-8">
      <div className="max-w-7xl mx-auto bg-white rounded-[32px] md:rounded-[40px] px-6 md:px-12 py-20 md:py-28 border border-neutral-200">
        <div className="text-center reveal">
          <span className="inline-block text-[11px] font-semibold tracking-[0.2em] uppercase text-neutral-800 bg-neutral-100 border border-neutral-200 px-3 py-1.5 rounded-full">
            Engagement
          </span>
          <h2 className="font-display-bold mt-6 text-4xl md:text-[64px] leading-[1.05] text-neutral-900">
            Engagement <span className="relative inline-block">
              <span className="relative z-10">Structure</span>
              <span className="absolute -inset-x-1 bottom-1 md:bottom-2 h-2 md:h-4 -z-0 rounded bg-[#E8DBC6]" />
            </span>
          </h2>
        </div>

        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {tiers.map((t, i) => (
            <div
              key={t.title}
              className="card-hover reveal relative rounded-[24px] p-7 md:p-8 bg-neutral-50 border border-neutral-200 flex flex-col"
              style={{ transitionDelay: `${i * 90}ms` }}
            >
              {/* Label */}
              <div className="text-[11px] font-semibold tracking-[0.2em] uppercase text-neutral-500">
                {t.label}
              </div>

              <div className="mt-5 h-px w-full bg-neutral-200" />

              {/* Title */}
              <h3 className="font-display-bold mt-5 text-[22px] md:text-[26px] leading-tight text-neutral-900">
                {t.title}
              </h3>

              <div className="mt-5 h-px w-full bg-neutral-200" />

              {/* Description */}
              <p className="mt-5 text-[14.5px] leading-relaxed text-neutral-600 flex-1">
                {t.desc}
              </p>

              <div className="mt-7 h-px w-full bg-neutral-200" />

              {/* CTA */}
              <a
                href="https://wa.me/918976171100"
            onClick={trackWhatsAppClick}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-5 inline-flex items-center gap-2 font-display-bold text-neutral-900 text-[15px] group"
              >
                {t.cta}
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
